"use strict";import{html as o}from"@cisco-u/base";export function ciscoSpotlight({height:e=155,width:i=157,hidden:t=!1,title:l="Cisco U. Spotlight"}={}){return o`<svg
    width=${i}
    height=${e}
    viewBox="0 0 157 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${l}"
    role="img"
  >
    <g opacity="0.8">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.567 127.474L15.7261 -10L134.83 67.8884C137.711 69.4304 140.752 71.2935 144 73.4999C154.41 90.2783 142.523 121.109 117.325 136.743C92.1262 152.378 61.5 153 52.8494 134.672C51.7816 132.41 51.0225 129.996 50.567 127.474Z"
        fill="url(#paint0_linear_116_2286)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.0411 112.618L16.3786 -7.32137L120.462 76.0929C122.135 76.7689 123.437 77.7803 124.281 79.1412C128.878 86.5502 118.172 101.511 100.369 112.557C82.5662 123.603 64.4074 126.551 59.8104 119.142C58.7007 117.354 58.4828 115.125 59.0411 112.618Z"
        fill="url(#paint1_linear_116_2286)"
        fill-opacity="0.8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.1136 104.322L16.6861 -7.78036L104.489 85.5C105.797 85.8436 106.796 86.4831 107.386 87.4344C109.904 91.4919 104.041 99.6849 94.2912 105.734C84.5417 111.783 74.5973 113.398 72.0799 109.34C71.2661 108.029 71.328 106.285 72.1136 104.322Z"
        fill="url(#paint2_linear_116_2286)"
        fill-opacity="0.8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.3974 99.0498L16.2718 -7.22742L95.0795 90.0273C96.2304 90.0391 97.0995 90.3679 97.5174 91.0414C98.659 92.8814 96.0004 96.5967 91.5792 99.3399C87.158 102.083 82.6484 102.815 81.5068 100.975C81.187 100.46 81.1654 99.7971 81.3974 99.0498Z"
        fill="url(#paint3_linear_116_2286)"
        fill-opacity="0.8"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_116_2286"
        x1="15.973"
        y1="-9.98241"
        x2="110.218"
        y2="128.119"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_116_2286"
        x1="18.3046"
        y1="-4.52973"
        x2="109.833"
        y2="117.593"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_116_2286"
        x1="16.8027"
        y1="-7.81143"
        x2="101.038"
        y2="108.889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_116_2286"
        x1="19.8064"
        y1="-1.24785"
        x2="102.559"
        y2="104.079"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg> `}
//# sourceMappingURL=ciscoSpotlight.js.map
